module.exports = __webpack_public_path__ + "img/014.6c6ceacf.jpg";